import * as tslib_1 from "tslib";
import { observable, action } from "mobx";
var GlobalTimeTicker = /** @class */ (function () {
    function GlobalTimeTicker() {
        this.tick = 0;
        this.interval = 500;
        this.tock();
    }
    GlobalTimeTicker.prototype.tock = function () {
        this.tick++;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.tock, this.interval);
    };
    tslib_1.__decorate([
        observable,
        tslib_1.__metadata("design:type", Number)
    ], GlobalTimeTicker.prototype, "tick", void 0);
    tslib_1.__decorate([
        action.bound,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", []),
        tslib_1.__metadata("design:returntype", void 0)
    ], GlobalTimeTicker.prototype, "tock", null);
    return GlobalTimeTicker;
}());
export { GlobalTimeTicker };
export var globalTimeTicker = new GlobalTimeTicker();
//# sourceMappingURL=GlobalTimeTicker.js.map